import styled from "styled-components";

export const DonationDetailsCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;

  @media (min-width: 1201px) {
    padding-left: 40px;
    border-left: solid 1px #8F8F8F;
  }
  
  @media (max-width: 1200px) {
    padding-top: 40px;
    border-top: solid 1px #8F8F8F;
  }
`

export const DonationDetailsH2 = styled.h2`
  margin-bottom: 20px;
`

export const DonationDetailsP = styled.p`
  font-size: var(--font-size-md);
  margin-bottom: 20px;
`

export const DonationDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  max-height: 714px;
  width: 295px;
  background-color: var(--color-order-detail-bg);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02);
`

export const DonationDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 30px;
  margin-bottom: 10px;
`

export const DonationDetailsContentP = styled.p`
  font-size: var(--font-size-sm);
  width: fit-content;
  margin-right: auto;
  color: var(--color-order-detail-subtext);
`

export const DonationDetailsCompanyName = styled.p`
  font-size: var(--font-size-sm);
  width: fit-content;
  max-width: 140px;
  text-align: right;
  margin-left: 35px;
  margin-right: 25px
`

export const DonationAmountDollars = styled.p`
  font-size: var(--font-size-xl);
  margin-bottom: 20px;
`

export const DonationAmountCents = styled.p`
  font-size: var(--font-size-md);
  margin-top: auto;
  margin-bottom: 23px;
`

export const DonationCurrency = styled.p`
  font-size: var(--font-size-md);
  margin-top: auto;
  margin-bottom: 23px;
  margin-left: 15px;
  color: var(--color-order-detail-subtext);
`

export const DonationDetailsBody = styled.div`
  margin-top: 35px;
  margin-bottom: auto;
`

export const DonationDetailsFooter = styled.div`
  margin-top: 35px;
`

export const DonationImage = styled.img`
  height: 160px;
  width: 240px;
  margin-top: 25px;
  margin-bottom: 10px;
`